<template>
  <div id="excellent">
    <img :src="logo" alt="">
  </div>
</template>

<script>
  import logo from "@/assets/images/excellent_logo.png";
  export default {
    name: "tutorial-excellent",
    data() {
      return {
        logo,
      };
    },
  }
</script>

<style lang="stylus" scoped>
  #excellent {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    img {
      width: 50px;
      height: 50px;
    }
  }
</style>